<template>
  <div>
    <div class="head">
      <div>
        <img class="logo" src="../../assets/img/logo-shopvidi-new.png" @click="$router.push({path: 'Order'})"/>
      </div>
      <div class="content1-right-personimg">
        <el-dropdown size="medium">
          <span class="el-dropdown-link"
                style="cursor:pointer;display:flex;align-items: center;justify-content: center;">
            <div class="user-icon"><img src="@/assets/img/use.png" width="17px" height="17px"/></div><span
            style="height:17px;height-line:17px">{{ showUsername }}</span><i
            class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="signOut">Sign Out</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 左侧菜单 -->
    <el-aside class="aside">
      <left-menu  :checkedMenu="checkedMenu" :firstMenuName="firstMenuName" :menuList="menuList"></left-menu>
    </el-aside>
    <!-- 公共的具备菜单的组件，包含面包屑，左侧菜单和显示的内容 -->
    <el-container class="menu-content-main">
      <!-- 主要内容，这里面内容动态显示 -->
      <el-main class="main-container">
        <order v-if="this.$route.params.key === 'Order'" ref="Order"/>
        <creatOrder v-else-if="this.$route.params.key === 'creatOrder'" ref="creatOrder"></creatOrder>
        <StoreReview v-else-if="this.$route.params.key === 'store-review'" ref="storeReview"></StoreReview>
        <editOrder v-else-if="this.$route.params.key === 'editOrder'" ref="editOrder"></editOrder>
        <ShippingDetail v-else-if="this.$route.params.key === 'shipping'" ref="shipping"/>
        <ShippingInvoice v-else-if="this.$route.params.key === 'shipping-invoice'" ref="shipping-invoice"/>
        <update-business v-else-if="this.$route.params.key === 'business-info'" ref="business-info"/>
        <!-- <vidirect-list v-else-if="this.$route.params.key === 'refer-retailers'" ref="refer-retailers"/> -->
        <brands v-else-if="this.$route.params.key === 'Brands'" ref="brands"/>
        <produts v-else-if="this.$route.params.key === 'Products'" ref="updateBusiness"/>
        <wallet v-else-if="this.$route.params.key === 'Wallet'" ref="Wallet"/>
        <spu-details v-else-if="this.$route.params.key === 'spuDetails'" ref="spuDetails"/>
        <wholesale-spu-detail v-else-if="this.$route.params.key === 'wholesale-spu-detail'"
                              ref="wholesale-spu-detail"/>
        <order-detail v-else-if="this.$route.params.key === 'OrderDetail'" ref="OrderDetail"></order-detail>
        <images-list v-else-if="this.$route.params.key ==='images'" ref="imagesList"></images-list>
        <service-order-list v-else-if="this.$route.params.key ==='service-order'"
                            ref="service-order"></service-order-list>
        <service-order-detail v-else-if="this.$route.params.key ==='service-order-detail'"
                              ref="service-order-detail"></service-order-detail>
        <refer-orders v-else-if="this.$route.params.key === 'refer-orders'" ref="refer-orders"/>
        <create-refer-order v-else-if="this.$route.params.key === 'create-refer-orders'" ref="create-refer-orders"/>
        <wholesale-create-refer-order v-else-if="this.$route.params.key === 'wholesale-create-refer-orders'"
                                      ref="wholesale-create-refer-orders"/>
        <refer-orders-detail v-else-if="this.$route.params.key === 'refer-orders-detail'" ref="refer-orders-detail"/>
        <procurement-orders v-else-if="this.$route.params.key === 'procurement-orders'"
                            ref="procurement-orders"/>
        <procurement-products v-else-if="this.$route.params.key === 'procurement-products'"
                              ref="procurement-products"/>
        <procurement-orders-create v-else-if="this.$route.params.key === 'procurement-orders-create'"/>
        <procurement-orders-detail v-else-if="this.$route.params.key === 'procurement-orders-detail'"/>
        <edit-item-avaliability v-else-if="this.$route.params.key==='edit-item-avaliability'" ref="edit-item-avaliability" />
        <logistic-detail v-else-if="this.$route.params.key==='logistics-detail'" ref="logistics-detail"/>
        <!--下面的是同一个页面多个入口,对应菜单与面包屑-->
        <invoice
          v-else-if="this.$route.params.key === 'invoice' || this.$route.params.key === 'procurement-orders-invoice' "
          ref="invoice"></invoice>
        <customer v-else-if="this.$route.params.key==='Customers'" ref="Customers"/>
        <customersDetail v-else-if="this.$route.params.key==='CustomersDetail'" ref="CustomersDetail"/>
        <!-- <Widget v-else-if="this.$route.params.key==='widget'" ref="widget"/> -->
        <sku-inventory
          v-else-if="this.$route.params.key === 'sku-inventory' || this.$route.params.key === 'procurement-sku-inventory'"/>

        <create-spu v-else-if="this.$route.params.key === 'CreateSpu'" ref="createSpu" ></create-spu>
        <opportunities v-else-if="this.$route.params.key==='Opportunities'" ref="Opportunities"></opportunities>
        <opportunitiesDetail v-else-if="this.$route.params.key==='opportunitiesDetail'" ref="opportunitiesDetail"></opportunitiesDetail>
        <!-- <explore v-else-if="this.$route.params.key==='Explore'" ref="Explore"></explore> -->
        <brand-home v-else-if="this.$route.params.key === 'home'"></brand-home>

        <!-- vilocal -->
        <ExploreParent v-else-if="this.$route.params.key==='Explore'" ref="explore" />
        <StoreBasedMarketingList v-else-if="this.$route.params.key==='store-based-marketing'" ref="storeBasedMarketing"/>
        <StoreBasedMarketingCreate v-else-if="this.$route.params.key==='create-store-based-marketing'" ref="createStoreBasedMarketing"/>
        <StoreBasedMarketingDetail v-else-if="this.$route.params.key==='store-based-marketing-detail'" ref="detailStoreBasedMarketing"/>
      </el-main>

    </el-container>
  </div>
</template>

<script>
import {Logout} from '@/api/manage.js'
import {loadSysRole} from './loadSysRole.js'
import Order from '../order/index'
import creatOrder from '../order/createOrder.vue'
import editOrder from '../order/editOrder.vue'
import invoice from '../order/invoice.vue'
import updateBusiness from '../business/update-business'
import VidirectList from '../vidirect/vidirect-list.vue'
import Brands from '../brands/index.vue'
import Produts from '../produts/index.vue'
import wallet from '../wallet'
import SpuDetails from '../spuDetails/index.vue'
import OrderDetail from '../order/orderDetail.vue'
import ImagesList from '../produts/images-list'
import ServiceOrderList from '../order/service-order/service-order-list'
import ServiceOrderDetail from '../order/service-order/service-order-detail'
import ReferOrders from '../vidirect/refer-orders'
import {useStore} from '../../store'
import SkuInventory from '../produts/sku-inventory'
import ReferOrdersDetail from '../vidirect/refer-orders-detail'
import ProcurementOrders from '../wholesale/procurement-orders'
import ProcurementProducts from '../wholesale/procurement-products'
import ProcurementOrdersCreate from '../wholesale/procurement-orders-create'
import ProcurementOrdersDetail from '../wholesale/procurement-orders-detail'
import WholesaleCreateReferOrder from '../vidirect/create-wholesale-refer-order.vue'
import CreateReferOrder from '../vidirect/create-refer-order.vue'
import WholesaleSpuDetail from '../spuDetails/wholesale-spu-detail.vue'
import editItemAvaliability from '../order/edit-item-avaliability'
import LogisticDetail from '../logistics/logistic-detail.vue'
import CreateSpu from '../spuDetails/create-spu'
import customer from '../customer/customer.vue'
import customersDetail from '../customer/customersDetail.vue'
import LeftMenu from './left-menu'
import BrandHome from '../home/brand-home'
import opportunities from '../customer/opportunities.vue'
import opportunitiesDetail from '../customer/opportunitiesDetail.vue'
import ExploreParent from '../vilocal/explore-parent.vue'
// import Explore from '../vilocal/explore.vue'
// import Widget from '../vilocal/widget.vue'
import StoreReview from '../order/store-review.vue'
import StoreBasedMarketingList from '../store-based-marketing/store-based-marketing-list.vue'
import StoreBasedMarketingCreate from '../store-based-marketing/store-based-marketing-create.vue'
import StoreBasedMarketingDetail from '../store-based-marketing/store-based-marketing-detail.vue'
import ShippingDetail from '../order/shipping/shipping-detail.vue'
import ShippingInvoice from '../order/shipping/shipping-invoice.vue'

export default {
  components: {
    BrandHome,
    LeftMenu,
    CreateSpu,
    WholesaleCreateReferOrder,
    CreateReferOrder,
    ProcurementOrdersCreate,
    ProcurementOrdersDetail,
    ProcurementOrders,
    ProcurementProducts,
    ReferOrdersDetail,
    ImagesList,
    OrderDetail,
    Order,
    creatOrder,
    editOrder,
    updateBusiness,
    Brands,
    Produts,
    wallet,
    invoice,
    ServiceOrderList,
    ServiceOrderDetail,
    VidirectList,
    ReferOrders,
    SpuDetails,
    SkuInventory,
    WholesaleSpuDetail,
    editItemAvaliability,
    LogisticDetail,
    customer,
    customersDetail,
    opportunities,
    opportunitiesDetail,
    // Explore,
    // Widget
    StoreReview,
    ExploreParent,
    StoreBasedMarketingList,
    StoreBasedMarketingCreate,
    StoreBasedMarketingDetail,
    ShippingDetail,
    ShippingInvoice

  },
  data() {
    return {
      breadCrumbList: [],
      checkedMenu: '',
      menuList: [],
      firstMenuName: '',
      showUsername: ''
    }
  },
  watch: {
    $route(n, o) {
      if (n.fullPath !== o.fullPath) { // 监听路由参数是否变化
        this.showUsername = this.username
        this.initMenu()
      }
    }
  },

  created() {
    this.loadSysRole()
    this.showUsername = this.username
  },
  methods: {
    signOut() {
      const token = this.$ls.get('token')
      // 登出操作，
      // 1、调用登出接口 2、删除token
      if (token !== undefined && token !== null) {
        Logout('/sys/logout', token).then(response => {
          if (response.success) {
            // 如果返回成功的话，将token清空
            this.$ls.set('token', null)
            this.login = false
            this.$router.push('/')
          } else {
            this.$message.warning(response.message)
          }
        })
      }
    },
    loadSysRole() {
      loadSysRole(response => {
        this.menuList = response
        this.initMenu()
      })
    },

    // 初始化左侧菜单和面包屑
    initMenu() {
      const menuKey = this.$route.params.key
      let breadCrumbList = this.getBreadCrumbList(this.menuList, menuKey)
      const firstMenuName = breadCrumbList[0] ? breadCrumbList[0].name : ''
      const checkedMenu = breadCrumbList[1] ? breadCrumbList[1].name : firstMenuName
      // 验证权限，没有权限访问那么则强行重定向（弃用）
      this.menuList.forEach((element, index) => {
        if (element.key === menuKey) {
          if (element.hidden) {
            let selectedIndex = index
            if (index === 0) {
              selectedIndex += 1
            } else {
              selectedIndex = 0
            }
            const pathKey = this.menuList[selectedIndex].redirect || this.menuList[selectedIndex].key
            this.$router.push({path: '/menu/' + pathKey})
          }
        }
      })
      let nonArr = ['Orders', 'Products', 'Customers', 'Refer Retailers']
      let flag = false
      breadCrumbList.forEach((element) => {
        if (nonArr.includes(element.name)) {
          flag = true
        }
      })
      console.log(breadCrumbList)
      if (flag) {
        breadCrumbList.splice(0, 1)
      }
      useStore().setBreadCrumbList(breadCrumbList)
      this.breadCrumbList = breadCrumbList
      this.firstMenuName = firstMenuName
      this.checkedMenu = checkedMenu
    },
    // 生成面包屑
    getBreadCrumbList(menuList, key) {
      let breadCrumbList = []
      menuList.forEach(element => {
        const pathKey = element.redirect || element.key
        const item = {path: '/menu/' + pathKey, name: element.name}
        // key 吻合，并且不在 集合中的第一个
        if (element.key === key) {
          breadCrumbList.push(item)
        } else if (element.childrenList) {
          let concatList = this.getBreadCrumbList(element.childrenList, key)
          if (concatList && concatList.length > 0) {
            breadCrumbList = [item, ...concatList]
          }
        }
      })
      return breadCrumbList
    }
    // checkedMenuFunction() {
    //   this.checkedMenu = ''
    //   this.firstMenuName = ''
    //   // 要默认选中菜单,要判断key是哪个
    //   let checkedKey = this.$route.params.key
    //   if (checkedKey !== undefined && checkedKey !== '' && checkedKey !== null) {
    //     let checkedMenuTemp = checkedKey
    //     this.menuList.forEach((element, index) => {
    //       if (element.key === checkedMenuTemp) {
    //         // notes 增加判断，如果选中的菜单没有权限访问那么则强行重定向
    //         if (element.hidden) {
    //           let selectedIndex = index
    //           if (index === 0) {
    //             selectedIndex += 1
    //           } else {
    //             selectedIndex = 0
    //           }
    //           this.$router.push({path: '/menu/' + this.menuList[selectedIndex].name})
    //           return
    //         }
    //         this.breadCrumbList = [
    //           {path: '/menu/' + element.key, name: element.name}
    //         ]
    //         // 给选中的2级菜单以及 所属1级菜单 赋值
    //         this.checkedMenu = element.name
    //         this.firstMenuName = element.name
    //         // 切换菜单，动态加载列表数据
    //         this.$nextTick(() => {
    //           this.$refs[element.key].loadData()
    //         })
    //         return
    //       }
    //       element.childrenList.forEach(child => {
    //         // 通过传来的key  将对应的name进行赋值给子组件
    //         if (child.key === checkedMenuTemp) {
    //           // 需要判断是从哪里点过来的
    //           this.breadCrumbList = [
    //             {path: '/menu/' + child.key, name: child.name}
    //           ]
    //           // 给选中的2级菜单以及 所属1级菜单 赋值
    //           this.checkedMenu = child.name
    //           this.firstMenuName = element.name
    //           // 切换菜单，动态加载列表数据
    //           this.$refs[child.key].loadData()
    //           return ''
    //         }
    //       })
    //     })
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>

.main-container {
  min-height: calc(100vh - 100px);
  width: calc(100% - 230px);
  min-width: 800px;
  margin-top: 80px;
  margin-left: 230px;
}

/deep/ .el-header {
  height: 30px !important;
}

/deep/ .el-divider--horizontal {
  margin: 20px 0px 0px
}

/deep/ .el-aside {
  background: #f7f7f7 !important;
  height: calc(100vh - 81px);
}

@media screen and (max-width: 600px) {
  // 移动端要隐藏左侧菜单
  .el-header {
    padding: 0px
  }

  .el-aside {
    display: none;
  }

  .menu-content-main {
    margin-top: 50px;
  }

  .el-main {
    padding: 30px;
  }

  /deep/ .el-breadcrumb {
    //width: 95vw !important;
    margin: 0 auto !important
  }
}

.head {
  display: flex;
  align-items: center;
  width: 100%;
  height: 80px;
  padding-left: 20px;
  padding-right: 60px;
  flex-direction: row;
  justify-content: space-between;
  position: fixed;
  background: #FFFFFF;
  border-bottom: 1px #E1E1E1 solid;
  min-width: 800px;
  z-index: 999;
  .logo {
    width: 174px;
    height: 43px;
    cursor: pointer;
  }

  .content1-right-personimg {

    right: 0px;
    height: 17px;
    padding: 5px;
    display: inline-block;
    transform: translate3d(0, -50%, 0);
    -webkit-transform: translate3d(0, -50%, 0);
  }
}

.user-icon {
  border-radius: 50%;
  background: #E1E1E1;
  margin-right: 10px;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.aside {
  position: fixed;
  top: 80px;
  width: 230px !important;
  border-right: 1px solid #E1E1E1;
  background: #f7f7f7;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/menu-index.vue